import { select } from '@ngrx/store';
import { getOneClickStdLot } from '@ordersnproducts/modules/one-click-order/selectors/one-click-jobsites.selector';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UnitCode } from '../../util/enums/one-click-unit.enum';

export class OneClickStandardLotBuilderProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.pipe(
      select(getOneClickStdLot),
      map(({ stdLot, loading }) => {
        if (loading) {
          return '';
        } else {
          if (stdLot && stdLot.lotMax !== undefined && stdLot && stdLot.lotMax !== null) {
            return `${stdLot.lotMax} ${UnitCode.Ton}`;
          } else {
            return '';
          }
        }
      }),
    );
  }
}
